import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { AccountAuthService, AuthError } from '../account-auth.service';
import { passwordRules } from '../password-field/password-field.component';

@Component({
  selector: 'app-signup-page',
  templateUrl: './signup-page.component.html',
  styleUrls: ['../auth-form.scss'],
  standalone: false,
})
export class SignupPageComponent implements OnInit {
  readonly form = this.fb.group({
    first_name: ['', [Validators.required, Validators.maxLength(100)]],
    last_name: ['', Validators.maxLength(100)],
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, passwordRules]],
    accept_terms: [false, Validators.requiredTrue],
  });

  busy = false;
  error: AuthError | null = null;
  /** Server's reason the password can't be used (too common, too close to the name). */
  passwordError: string | null = null;

  constructor(
    private fb: FormBuilder,
    private auth: AccountAuthService,
    private route: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    // Invitation emails link here with the invited address filled in.
    const email = this.route.snapshot.queryParamMap.get('email');
    if (email) this.form.patchValue({ email });
    this.auth.rememberReturnTo(this.route.snapshot.queryParamMap.get('returnTo'));
    this.form.controls.password.valueChanges.subscribe(() => (this.passwordError = null));
  }

  invalid(name: 'first_name' | 'email' | 'accept_terms'): boolean {
    const c = this.form.controls[name];
    return c.invalid && c.touched;
  }

  submit(): void {
    if (this.busy) return;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const value = this.form.getRawValue();
    this.busy = true;
    this.error = null;
    this.passwordError = null;

    this.auth
      .signup({
        first_name: value.first_name!.trim(),
        last_name: (value.last_name || '').trim(),
        email: value.email!.trim(),
        password: value.password!,
        accept_terms: !!value.accept_terms,
      })
      .subscribe({
        next: (res) => {
          this.router.navigate(['/verify-email'], { queryParams: { email: res.email } });
        },
        error: (err) => {
          this.busy = false;
          const error = this.auth.toError(err);
          if (error.code === 'weak_password') {
            this.passwordError = error.message;
          } else {
            this.error = error;
          }
          this.cdr.detectChanges();
        },
      });
  }
}
